import React from 'react';
import { siteConfig } from '../config/siteConfig';
import { LeadForm } from '../components/LeadForm';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="w-full bg-brand-navy py-24 md:py-40 relative overflow-hidden" data-id="element-159">
      {/* Ambient Glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-gold/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-160"></div>
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-gold/8 rounded-full blur-[120px] translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-161"></div>

      {/* Noise Texture */}
      <div className="absolute inset-0 bg-noise opacity-[0.03] pointer-events-none mix-blend-overlay" data-id="element-162"></div>

      <div className="container mx-auto px-4 max-w-7xl relative z-10" data-id="element-163">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-center" data-id="element-164">
          {/* Left Column - Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-165">
            <img src={siteConfig.brand.logoWhite} alt="Let Lois" className="h-10 w-auto mb-10 mx-auto lg:mx-0 opacity-80" data-id="element-166" />
            <h2 className="font-serif text-4xl md:text-6xl font-medium text-white mb-8 leading-[1.1] tracking-tight" data-id="element-167">
              {siteConfig.cta.headline}
            </h2>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-xl mx-auto lg:mx-0 font-light" data-id="element-168">
              {siteConfig.cta.subtext}
            </p>
          </motion.div>

          {/* Right Column - Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/2 max-w-md mx-auto lg:max-w-none relative" data-id="element-169">
            <LeadForm variant="dark" data-id="element-170" />
          </motion.div>
        </div>
      </div>
    </section>;
}